import { render, staticRenderFns } from "./select-level.vue?vue&type=template&id=e135c482"
import script from "./select-level.vue?vue&type=script&lang=ts"
export * from "./select-level.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports